import React from 'react';
import PropTypes from 'prop-types';
import PullTicket from 'components/svgs/icons/pull-ticket';
import cx from 'classnames';

import Brand from 'models/brand';
import Booking from 'models/booking';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  buttonStyle: PropTypes.string,
};

const defaultProps = {
  buttonStyle: null,
};

const ViewReceipt = ({ booking, buttonStyle, brand }) => {
  let buttonText;
  let icon;
  let buttonClasses;

  if (buttonStyle === 'inline') {
    buttonText = 'Receipt';
    icon = <PullTicket />;
    buttonClasses = cx({
      'btn': true,
      'btn-bp': brand.isBestParking,
      'btn-deco-doc': true,
      'btn-block': true,
      'btn-alternate': true,
    });
  } else {
    buttonText = 'View Receipt';
    icon = <span className="iconified-font iconified-paper-receipt margin-right-10 text-size-16" />;
    buttonClasses = cx({
      'display-block': true,
      'text-align-center': true,
      'padding-vertical-10': true,
      'text-color-hover-white': true,
      'text-size-12': true,
      'margin-bottom-10': true,
      'border-style-solid': true,
      'border-side-all': true,
      'border-radius-2': true,
      'background-color-hover-bp-blue': brand.isBestParking,
      'border-color-bp-blue': brand.isBestParking,
      'text-color-bp-blue': brand.isBestParking,
      'background-color-hover-green': !brand.isBestParking,
      'border-color-green': !brand.isBestParking,
      'text-color-green': !brand.isBestParking,
    });
  }

  return (
    <a href={booking.anonymousReceiptUrl} className={buttonClasses}>
      {icon}
      <span>{buttonText}</span>
    </a>
  );
};

ViewReceipt.propTypes = propTypes;
ViewReceipt.defaultProps = defaultProps;

export default ViewReceipt;
